import { CheckCircle2, XCircle } from "lucide-react";

const bestFit = [
  "Practices typically around $80K–$100K+ per month in collections",
  "Owners who want a partner, not random tactics",
  "Teams that value clarity, tracking, and accountability",
  "Practices open to coordinated website, ads, and direct-mail systems",
];

const notFit = [
  "Practices looking only for the cheapest vendor",
  "Owners expecting a magic bullet without execution",
  "Teams that want a report but do not intend to act on it",
  "Practices comparing agencies only on price",
];

const CheckupFitSection = () => (
  <section id="who-its-for" className="py-14 md:py-20 bg-hero-bg">
    <div className="max-w-4xl mx-auto section-padding">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-bold text-hero-foreground tracking-tight mb-3">
          Who This Is Built For
        </h2>
        <p className="text-hero-foreground/50 max-w-2xl mx-auto text-sm leading-relaxed">
          This checkup is designed for dental owners who take growth seriously and want a clearer read on what is helping or hurting their new-patient flow.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {/* Best fit */}
        <div className="bg-card rounded-2xl p-6 border border-border">
          <p className="font-semibold text-foreground mb-4 text-sm uppercase tracking-wide">Best Fit</p>
          <ul className="space-y-3">
            {bestFit.map((item) => (
              <li key={item} className="flex items-start gap-2.5 text-sm text-foreground/80">
                <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0 mt-0.5" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Not fit */}
        <div className="bg-card rounded-2xl p-6 border border-border">
          <p className="font-semibold text-foreground mb-4 text-sm uppercase tracking-wide">Probably Not the Right Step</p>
          <ul className="space-y-3">
            {notFit.map((item) => (
              <li key={item} className="flex items-start gap-2.5 text-sm text-muted-foreground">
                <XCircle className="w-4 h-4 text-muted-foreground/50 shrink-0 mt-0.5" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default CheckupFitSection;
